class PageWithMenu extends HTMLElement {
  constructor() {
    super();
    this.PageElement = this.querySelector('[data-page]');

    // Catch click on navigation
    this.PageElement.querySelectorAll('[data-page-nav-link]').forEach(link => link.addEventListener('click', this.linkClick.bind(this,event,link)));


  }

  linkClick(event,link) {
    const title = link.dataset.pageNavLink;

    // Only do something when the tab is not active
    if (!link.classList.contains('is-active')) {

      // Close the active tab and open the clicked tab after that
      this.closeActivePage(title);

      // Open the clicked tag link
      this.openPageNavLink(title);
    }
  }

  closeActivePage(title) {
    const activePage = this.PageElement.querySelector('.is-active');
    // If there is an active tab
    if (activePage) {

      // Get title
      const activeTitle = activePage.dataset.pageNavLink;

      // Don't reopen self
      if (activeTitle === title) {
        return;
      }

      this.closePage(activeTitle);
      this.closePageNavLink(activeTitle);
    }

    this.openPage(title);
  }

  closeCurrentPage(title) {
    const activePage = this.PageElement.querySelector('.is-active');
    // If there is an active tab
    if (activePage) {

      // Get title
      const activeTitle = activePage.dataset.pageNavLink;

      // Close current tab
      this.closePage(activeTitle);
    }
  }

  closePage(title) {
    // Close the tab and tab link content
    this.PageElement.querySelector('[data-page-content-pane="' + title + '"]').classList.remove('is-active');
    this.PageElement.querySelector('[data-page-nav-link="' + title + '"]').classList.remove('is-active');
  }

  closePageNavLink(title) {
    // Close the tab link in nav
    this.PageElement.querySelector('[data-page-nav-link="' + title + '"]').classList.remove('is-active');
  }

  openPage(title) {
    // Open new tab and the tab content
    this.PageElement.querySelector('[data-page-content-pane="' + title + '"]').classList.add('is-active');
    this.PageElement.querySelector('[data-page-nav-link="' + title + '"]').classList.add('is-active');
  }

  openPageNavLink(title) {
    // Open new tab
    this.PageElement.querySelector('[data-page-nav-link="' + title + '"]').classList.add('is-active');
  }
}
customElements.define('page-with-menu', PageWithMenu);
